/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiChannelBindings } from '../models/AaiChannelBindings';
import { AaiChannelBindingsDefinition } from '../models/AaiChannelBindingsDefinition';
import { AaiChannelItem } from '../models/AaiChannelItem';
import { AaiCorrelationId } from '../models/AaiCorrelationId';
import { AaiHeaderItem } from '../models/AaiHeaderItem';
import { AaiMessage } from '../models/AaiMessage';
import { AaiMessageBindings } from '../models/AaiMessageBindings';
import { AaiMessageBindingsDefinition } from '../models/AaiMessageBindingsDefinition';
import { AaiMessageTrait } from '../models/AaiMessageTrait';
import { AaiMessageTraitDefinition } from '../models/AaiMessageTraitDefinition';
import { AaiOperationBindings } from '../models/AaiOperationBindings';
import { AaiOperationBindingsDefinition } from '../models/AaiOperationBindingsDefinition';
import { AaiOperationTrait } from '../models/AaiOperationTrait';
import { AaiOperationTraitDefinition } from '../models/AaiOperationTraitDefinition';
import { AaiParameter } from '../models/AaiParameter';
import { AaiServer } from '../models/AaiServer';
import { AaiServerBindings } from '../models/AaiServerBindings';
import { AaiServerBindingsDefinition } from '../models/AaiServerBindingsDefinition';
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { AuthorizationCodeOAuthFlow } from '../../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../core/models/common/ClientCredentialsOAuthFlow';
import { Components } from '../../core/models/common/Components';
import { ImplicitOAuthFlow } from '../../core/models/common/ImplicitOAuthFlow';
import { OAuthFlows } from '../../core/models/common/OAuthFlows';
import { PasswordOAuthFlow } from '../../core/models/common/PasswordOAuthFlow';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { Server } from '../../core/models/common/Server';
import { ServerVariable } from '../../core/models/common/ServerVariable';
import { NodePathVisitor } from '../../core/visitors/NodePathVisitor';

/**
 * A node path visitor for AsyncAPI.
 * @author eric.wittmann@gmail.com
 * @author Jakub Senko <jsenko@redhat.com>
 * @class
 * @extends NodePathVisitor
 */
export class AaiNodePathVisitor extends NodePathVisitor implements IAaiVisitor {
    public constructor() {
        super();
    }

    /**
     * 
     * @param {AuthorizationCodeOAuthFlow} node
     */
    public visitAuthorizationCodeOAuthFlow(node : AuthorizationCodeOAuthFlow) {
        this.path.prependSegment(Constants.PROP_AUTHORIZATION_CODE, false);
    }

    /**
     * 
     * @param {AaiChannelItem} node
     */
    public visitChannelItem(node : AaiChannelItem) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_CHANNELS, false);
    }

    /**
     * 
     * @param {ClientCredentialsOAuthFlow} node
     */
    public visitClientCredentialsOAuthFlow(node : ClientCredentialsOAuthFlow) {
        this.path.prependSegment(Constants.PROP_CLIENT_CREDENTIALS, false);
    }

    /**
     * 
     * @param {Components} node
     */
    public visitComponents(node : Components) {
        this.path.prependSegment(Constants.PROP_COMPONENTS, false);
    }

    /**
     * 
     * @param {AaiCorrelationId} node
     */
    public visitCorrelationId(node : AaiCorrelationId) {
        if(node.getName() != null) {
            this.path.prependSegment(node.getName(), true);
            this.path.prependSegment(Constants.PROP_CORRELATION_IDS, false);
        } else {
            this.path.prependSegment(Constants.PROP_CORRELATION_ID, false);
        }
    }

    /**
     * 
     * @param {AaiHeaderItem} node
     */
    public visitHeaderItem(node : AaiHeaderItem) {
        this.path.prependSegment(Constants.PROP_HEADERS, false);
    }

    /**
     * 
     * @param {ImplicitOAuthFlow} node
     */
    public visitImplicitOAuthFlow(node : ImplicitOAuthFlow) {
        this.path.prependSegment(Constants.PROP_IMPLICIT, false);
    }

    /**
     * 
     * @param {AaiMessage} node
     */
    public visitMessage(node : AaiMessage) {
        if(node.getName() != null) {
            this.path.prependSegment(node.getName(), true);
            this.path.prependSegment(Constants.PROP_MESSAGES, false);
        } else {
            if(!node._isOneOfMessage) {
                this.path.prependSegment(Constants.PROP_MESSAGE, false);
            } else {
                let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_ONE_OF);
                if(idx !== -1) {
                    this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
                    this.path.prependSegment(Constants.PROP_ONE_OF, false);
                } else {
                    throw Object.defineProperty(new Error("oneOf message without an index"), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.IllegalStateException','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
                }
            }
        }
    }

    /**
     * 
     * @param {AaiMessageTrait} node
     */
    public visitMessageTrait(node : AaiMessageTrait) {
        let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_TRAITS);
        if(idx !== -1) {
            this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
            this.path.prependSegment(Constants.PROP_TRAITS, false);
        } else {
            throw Object.defineProperty(new Error("message trait without an index"), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.IllegalStateException','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
        }
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageTraitDefinition(io.apicurio.datamodels.asyncapi.models.AaiMessageTraitDefinition)
     * @param {AaiMessageTraitDefinition} node
     */
    public visitMessageTraitDefinition(node : AaiMessageTraitDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_MESSAGE_TRAITS, false);
    }

    /**
     * 
     * @param {OAuthFlows} node
     */
    public visitOAuthFlows(node : OAuthFlows) {
        this.path.prependSegment(Constants.PROP_FLOWS, false);
    }

    /**
     * 
     * @param {AaiOperationTrait} node
     */
    public visitOperationTrait(node : AaiOperationTrait) {
        let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_TRAITS);
        if(idx !== -1) {
            this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
            this.path.prependSegment(Constants.PROP_TRAITS, false);
        } else {
            throw Object.defineProperty(new Error("operation trait without an index"), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.IllegalStateException','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
        }
    }

    /**
     * 
     * @param {AaiOperationTraitDefinition} node
     */
    public visitOperationTraitDefinition(node : AaiOperationTraitDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_OPERATION_TRAITS, false);
    }

    /**
     * 
     * @param {PasswordOAuthFlow} node
     */
    public visitPasswordOAuthFlow(node : PasswordOAuthFlow) {
        this.path.prependSegment(Constants.PROP_PASSWORD, false);
    }

    /**
     * 
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        this.path.prependSegment(node.getSchemeName(), true);
        this.path.prependSegment(Constants.PROP_SECURITY_SCHEMES, false);
    }

    /**
     * 
     * @param {Server} node
     */
    public visitServer(node : Server) {
        this.path.prependSegment((<AaiServer>node).getName(), true);
        this.path.prependSegment(Constants.PROP_SERVERS, false);
    }

    /**
     * 
     * @param {ServerVariable} node
     */
    public visitServerVariable(node : ServerVariable) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_VARIABLES, false);
    }

    /**
     * 
     * @param {AaiParameter} node
     */
    public visitAaiParameter(node : AaiParameter) {
        if(node.getName() != null) {
            this.path.prependSegment(node.getName(), true);
            this.path.prependSegment(Constants.PROP_PARAMETERS, false);
        } else {
            let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_PARAMETERS);
            if(idx !== -1) {
                this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
                this.path.prependSegment(Constants.PROP_PARAMETERS, false);
            }
        }
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitServerBindings(io.apicurio.datamodels.asyncapi.models.AaiServerBindings)
     * @param {AaiServerBindings} node
     */
    public visitServerBindings(node : AaiServerBindings) {
        this.path.prependSegment(Constants.PROP_BINDINGS, false);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitServerBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiServerBindingsDefinition)
     * @param {AaiServerBindingsDefinition} node
     */
    public visitServerBindingsDefinition(node : AaiServerBindingsDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_SERVER_BINDINGS, false);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOperationBindings(io.apicurio.datamodels.asyncapi.models.AaiOperationBindings)
     * @param {AaiOperationBindings} node
     */
    public visitOperationBindings(node : AaiOperationBindings) {
        this.path.prependSegment(Constants.PROP_BINDINGS, false);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOperationBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiOperationBindingsDefinition)
     * @param {AaiOperationBindingsDefinition} node
     */
    public visitOperationBindingsDefinition(node : AaiOperationBindingsDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_OPERATION_BINDINGS, false);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageBindings(io.apicurio.datamodels.asyncapi.models.AaiMessageBindings)
     * @param {AaiMessageBindings} node
     */
    public visitMessageBindings(node : AaiMessageBindings) {
        this.path.prependSegment(Constants.PROP_BINDINGS, false);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiMessageBindingsDefinition)
     * @param {AaiMessageBindingsDefinition} node
     */
    public visitMessageBindingsDefinition(node : AaiMessageBindingsDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_MESSAGE_BINDINGS, false);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitChannelBindings(io.apicurio.datamodels.asyncapi.models.AaiChannelBindings)
     * @param {AaiChannelBindings} node
     */
    public visitChannelBindings(node : AaiChannelBindings) {
        this.path.prependSegment(Constants.PROP_BINDINGS, false);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitChannelBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiChannelBindingsDefinition)
     * @param {AaiChannelBindingsDefinition} node
     */
    public visitChannelBindingsDefinition(node : AaiChannelBindingsDefinition) {
        this.path.prependSegment(node.getName(), true);
        this.path.prependSegment(Constants.PROP_CHANNEL_BINDINGS, false);
    }
}
AaiNodePathVisitor["__class"] = "io.apicurio.datamodels.asyncapi.visitors.AaiNodePathVisitor";
AaiNodePathVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor"];





import { IAaiVisitor } from './IAaiVisitor';

